<div class="home-slides owl-carousel owl-theme">
    <div class="main-banner-four item-bg-1">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                            <div class="banner-image">
                                <img src="assets/img/round_move.png" class="rotating"  alt="banner-img">
                            </div>
                        </div>
                        
                        <div class="col-lg-6 col-md-12">
                            <div class="hero-content">
                                <h1>Your technology partner <span>innovative and impactful</span> digital solutions </h1>
                                <p>We proactively consult, design, develop & scale robust web, mobile & custom software solutions, that fuel innovation & deliver digital success!</p>
                                <a routerLink="/quotation-request" class="btn btn-primary">Let's Discuss</a>
                             <!--   <a href="https://www.youtube.com/watch?v=bk7McNUjWgw" class="video-btn">Play Now<i class="icofont-play-alt-3"></i></a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="main-banner-four item-bg-2">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                            <div class="banner-image">
                                <img
                                    src="assets/img/hero_itajer_eng.png"
                                    alt="banner-img"
                                />
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div
                                class="hero-content"
                                style="position: relative"
                            >
                                <h1>
                                    <span>Grow your business with<br /></span
                                    >I-Tajer<span> Entrepreneur </span>Partner
                                </h1>
                                <p>
                                    I-Tajer is an ERP system that organizes your
                                    business from a cycle of buying, selling,
                                    E-invoicing with a human resource system and
                                    inventory
                                </p>
                                <a
                                    href="https://www.itajer.com/en/"
                                    style="z-index: 10"
                                    class="btn btn_itajer-primary"
                                    >For more about I-Tajer</a
                                >
                                <div>
                                    <img
                                        src="assets/img/itajer.png"
                                        alt=""
                                        style="
                                            bottom: -20px;
                                            left: 200px;
                                            position: absolute;
                                            width: 350px;
                                            z-index: 0;
                                        "
                                    />
                                </div>
                                <!--   <a href="https://www.youtube.com/watch?v=bk7McNUjWgw" class="video-btn">Play Now<i class="icofont-play-alt-3"></i></a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="main-banner-four item-bg-2">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                            <div class="banner-image">
                                <img src="assets/img/slide3.png" alt="banner-img">
                            </div>
                        </div>
                        
                        <div class="col-lg-6 col-md-12">
                            <div class="hero-content">
                                <h1><span>Your Product. Your Idea.<br> Our </span>Innovation<span> and </span>Engineering</h1>
                                <p>Accelerate your vision forward with our comprehensive suite of software development and growth services.</p>
                                <a routerLink="/quotation-request" class="btn btn-primary">Contact Us</a>
                      <!--   <a href="https://www.youtube.com/watch?v=bk7McNUjWgw" class="video-btn">Play Now<i class="icofont-play-alt-3"></i></a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="main-banner-four item-bg-3">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                            <div class="banner-image">
                                <img style="border-radius: 25px;" src="assets/img/slide_new_1.png"  alt="banner-img">
                            </div>
                        </div>
                        
                        <div class="col-lg-6 col-md-12">
                            <div class="hero-content">
                                <h1>Transform to <span>Intelligent Enterprise</span> with Odoo ERP</h1>
                                <p>Intelligent ERP business Suite enables businesses to transact, analyze and predict in real-time basis for organizations looking to prosper in the digital world.</p>
                                <a routerLink="/quotation-request" class="btn btn-primary">Plan Now</a>
                                <!--   <a href="https://www.youtube.com/watch?v=bk7McNUjWgw" class="video-btn">Play Now<i class="icofont-play-alt-3"></i></a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<section class="services-area bg ptb-100">
    <div class="container">
        <div class="section-title">
         <!--   <span>We work with you not for you</span> -->
            <h3>Digitalize your business.</h3>
            <p>We proactively consult, design, develop & scale robust web, mobile & custom software solutions, that fuel innovation & deliver digital success!</p>
           
        </div>
        
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-automation"></i>
                    </div>
                    <h3>Odoo Customization and Support</h3>
                    <p>Odoo Customization for Any Business - Any Industries</p>
                    <a routerLink="/odoo-customization-and-support-service" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-dashboard-web"></i>
                    </div>
                    <h3>Web Application Development</h3>
                    <p>Leading-edge web development services to fuel your business growth</p>
                    <a routerLink="/web-application-development-service" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-stock-mobile"></i>
                    </div>
                    <h3>Mobile Application Development</h3>
                    <p>Building beautiful applications right from imagination</p>
                    <a routerLink="/mobile-application-development-service" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-shopping-cart"></i>
                    </div>
                    <h3>Ecommerce Development</h3>
                    <p>End-to-end ecommerce development services in any framework</p>
                    <a routerLink="/ecommerce-development-service" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-code"></i>
                    </div>
                    <h3>Custom Development</h3>
                    <p>Custom Development for any requirement in any framework</p>
                    <a routerLink="/custom-development-service" class="read-more-btn">Read More</a>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services">
                    <div class="icon">
                        <i class="icofont-cloudapp"></i>
                    </div>
                    <h3>Cloud Services and Cyber Security</h3>
                    <p>Cloud Services and Cyber Security is essential need of every organization</p>
                    <a routerLink="/cloud-server-and-cyber-securities-service" class="read-more-btn">Read More</a>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="about-area ptb-100 bg-fbf9f8">
    <div class="container">
       

        <div class="about-inner-area">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="row about-image">
                        <div class="col-6 col-lg-6 col-md-6">
                            <div class="image">
                                <img src="assets/img/home2.jpg" alt="about">
                            </div>
                        </div>
                        <div class="col-6 col-lg-6 col-md-6">
                            <div class="image">
                                <img src="assets/img/home1.jpg" alt="about">
                            </div>
                        </div>
                        <div class="col-6 col-lg-6 col-md-6">
                            <div class="image mt-30">
                                <img src="assets/img/home3.jpg" alt="about">
                            </div>
                        </div>
                        <div class="col-6 col-lg-6 col-md-6">
                            <div class="image mt-30">
                                <img src="assets/img/home4.jpg" alt="about">
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-6 col-md-12">
                    <div class="about-text">
                        <span>Saudi Technology Innovation Company</span>
                        <h3>WHY OSIT ?</h3>
                        <ul style="font-style:italic">
                         <li>   We analyze, develop and implement business solutions related to the technologies that help global companies to focus on their business.<br>&nbsp;<br></li>


                           <li> Time and cost-effective customized applications that help organizations address functional gaps and achieve business goals effectively business value.<br>&nbsp;<br></li>
                            
                            
                         <li>   Our goal is to provide quality software in all aspects of the life cycle of the development from initial contact till post-development support.</li>   
                        </ul>
                            <a routerLink="/about" class="read-more-btn">View More About us.</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="rocket animate__animated animate__fadeInUp wow slow"><img src="assets/img/2030.png" alt="rocket"></div>
    <div class="vector"><img src="assets/img/vector-bg.png" alt="vector"></div>
    <div class="circle-pattern-2"></div>
</section>
<section class="working-process-area ptb-100 bg-fbf9f8">
    <div class="container">
        <div class="section-title">
          <!--  <span>Work Flow</span> -->
            <h3>Our Working Process</h3>
            <p>We enjoy adapting our strategies to offer every client the best solutions that are at the forefront of the industry.</p>
           <!-- <a routerLink="/about" class="read-more-btn">Read More</a> -->
        </div>
        <div class="row">
            <div class="col-lg-3 col-sm-6 col-md-3">
                <div class="single-work-process">
                    <div class="icon">
                        <i class="icofont-read-book"></i>
                    </div>
                    <h3>Planning</h3>
                </div>
            </div>
            
            <div class="col-lg-3 col-sm-6 col-md-3">
                <div class="single-work-process">
                    <div class="icon">
                        <i class="icofont-light-bulb"></i>
                    </div>
                    <h3>Research</h3>
                </div>
            </div>
            
            <div class="col-lg-3 col-sm-6 col-md-3">
                <div class="single-work-process">
                    <div class="icon">
                        <i class="icofont-code"></i>
                    </div>
                    <h3>Development</h3>
                </div>
            </div>
            
            <div class="col-lg-3 col-sm-6 col-md-3">
                <div class="single-work-process">
                    <div class="icon">
                        <i class="icofont-laptop-alt"></i>
                    </div>
                    <h3>Go Live</h3>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="analysis-area ptb-100 bg-fbf9f8">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-12">
                <div class="analysis-form">
                    <h3>Request Free Consultancy</h3>
                    <form>
                        <div class="form-group">
                            <input type="text" [(ngModel)]="name" [ngModelOptions]="{standalone: true}" placeholder="Name*" class="form-control">
                        </div>
                        
                        <div class="form-group">
                            <input type="text" [(ngModel)]="phone" [ngModelOptions]="{standalone: true}" placeholder="Phone*" class="form-control">
                        </div>
                        <div class="form-group">
                            <input type="email" [(ngModel)]="email" [ngModelOptions]="{standalone: true}" placeholder="Email" class="form-control">
                        </div>
                        <div class="form-group">
                            <input type="text" [(ngModel)]="subject" [ngModelOptions]="{standalone: true}" placeholder="Subject" class="form-control">
                        </div>
                        <div class="form-group">
                            <textarea placeholder="Message" [(ngModel)]="message" [ngModelOptions]="{standalone: true}" class="form-control"></textarea>
                        </div>
                        
                        <button type="button" (click)="onSubmit()" class="btn btn-primary">Request Now</button>
                    </form>
                </div>
            </div>
            
            <div class="col-lg-7 col-md-12">
                <div class="analysis-text">
                  <!--  <span>Free SEO Analysis</span> -->
                    <h3>Your Trusted Partner on The Digital Journey</h3>
                    <p>In a world that is anything but changing, we step in to help business steer their course to the top. Putting together the right mix of human ingenuity and technical capabilities, we help narrate your success story and turn it into a reality.</p>
                    <ul >
                        <li><span style="font-size: 20px;"><b>O</b></span>ptimum</li>
                        <li><span style="font-size: 20px;"><b>S</b></span>implicity</li>
                        <li><span style="font-size: 20px;"><b>I</b></span>ntegrity</li>
                        <li><span style="font-size: 20px;"><b>T</b></span>rust and Respect</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>


<!--
<section class="testimonial-area ptb-100 bg-fbf9f8">
    <div class="container">
        <div class="section-title">
            <span>Testimonial</span>
            <h3>What our client are saying</h3>
            <p>We enjoy adapting our strategies to offer every client the best solutions that are at the forefront of the industry.</p>
        </div>
        <div class="feedback-slides owl-carousel owl-theme">
            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar1.jpg" alt="client">
                    </div>
                    <h4>Josh Buttler</h4>
                    <span>Web Developer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar2.jpg" alt="client">
                    </div>
                    <h4>David Andy</h4>
                    <span>Web Designer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar3.jpg" alt="client">
                    </div>
                    <h4>Lina D'Souja</h4>
                    <span>QA Developer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar1.jpg" alt="client">
                    </div>
                    <h4>Sarah Taylor</h4>
                    <span>Team Lead</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar2.jpg" alt="client">
                    </div>
                    <h4>John Smith</h4>
                    <span>Web Developer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>

            <div class="single-feedback">
                <div class="client-info">
                    <div class="img">
                        <img src="assets/img/client-avatar3.jpg" alt="client">
                    </div>
                    <h4>Eva Lucy</h4>
                    <span>PHP Developer</span>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod incididunt ut labore et dolore magna aliqua. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                <i class="icofont-quote-right"></i>
            </div>
        </div>
    </div>
 
    <div class="vector"><img src="assets/img/vector-bg.png" alt="vector"></div>
</section> -->

<section class="funfacts-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-6 col-lg-3 col-sm-3 col-md-3">
                <div class="fun-fact">
                    <i class="icofont-users-alt-5"></i>
                    <p>Active Clients:</p>
                    <h3><span class="odometer" data-count="200">00</span><span class="sign">+</span></h3>
                </div>
            </div>
            
            <div class="col-6 col-lg-3 col-sm-3 col-md-3">
                <div class="fun-fact">
                    <i class="icofont-rocket-alt-2"></i>
                    <p>Success Rate:</p>
                    <h3><span class="odometer" data-count="91">00</span><span class="sign">%</span></h3>
                </div>
            </div>
            
            <div class="col-6 col-lg-3 col-sm-3 col-md-3">
                <div class="fun-fact">
                    <i class="icofont-laptop-alt"></i>
                    <p>Projects Done:</p>
                    <h3><span class="odometer" data-count="550">00</span><span class="sign">+</span></h3>
                </div>
            </div>
            
            <div class="col-6 col-lg-3 col-sm-3 col-md-3">
                <div class="fun-fact">
                    <i class="icofont-award"></i>
                    <p>Awards:</p>
                    <h3><span class="odometer" data-count="14">00</span><span class="sign">+</span></h3>
                </div>
            </div>
        </div>
    </div>
</section>



<div class="partner-area ptb-100  bg-fbf9f8">
    <div class="container">
        <div class="partner-slides owl-carousel owl-theme">
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/1.png" alt="partner"></a>
            </div>
        <!--<div class="partner-item">
                <a href="#"><img src="assets/img/client/2.png" alt="partner"></a>
            </div> -->
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/3.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/4.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/5.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/6.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/7.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/8.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/9.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/10.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/11.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/12.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/13.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/14.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/15.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/16.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/17.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/18.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/19.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/20.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/21.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/22.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/23.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/24.png" alt="partner"></a>
            </div>
            <div class="partner-item">
                <a href="#"><img src="assets/img/client/25.png" alt="partner"></a>
            </div>
            
           
        </div>
    </div>
    <div class="vector"><img src="assets/img/vector-bg.png" alt="vector"></div>
</div>

<section class="blog-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span>Our News</span> 
            <h3>Latest Blog Posts</h3>
            <p>We enjoy adapting our strategies to offer every client the best solutions that are at the forefront of the industry.</p>
            <a routerLink="/blogs" class="read-more-btn">View More Blogs</a>
        </div>
        <div class="blog-slides owl-carousel owl-theme">
           

          
            
            <div class="single-blog-post" *ngFor="let lblog of latestblogs;">
                <a href="blog-details/{{ lblog.blog.id }}" class="blog-image"><img style="height: 309px; width: 453px;" src="http://admin.osit.com.sa/uploads/blogimages/{{ lblog.blog.image }}" alt="blog"></a>
                <div class="blog-post-content">
                    <span>{{ lblog.category.title }}</span>
                    <h3><a routerLink="/blog-details/{{ lblog.blog.id }}">{{ lblog.blog.title }}</a></h3>
                    <p>{{ lblog.blog.content }}</p>

                    <a routerLink="/blog-details/{{ lblog.blog.id }}" class="read-more-btn">Read More</a>
                </div>
            </div>
        </div>
    </div>
</section>

<app-subscribe></app-subscribe>